import { WidgetDefinition } from '../models/WidgetDefinition';

export const spotValuesWidgetDefinition: WidgetDefinition = {
    baseType: 'spotValuesWidget',
    group: 'Charts',
    hasImage: true,
    highlights: ['Spot manual input identifiers of selected group'],
    icon: 'fa-map-pin',
    sortingOrder: 1350,
    title: 'Spot values',
    type: 'spotValuesWidget'
};